// GLG wordmark (white), extracted from the GLG_LOGO_MASTER_RGB_WHITE Figma asset —
// background tiles dropped so it sits directly on the dark header bar. viewBox is
// cropped to the glyph bounds (intrinsic aspect ratio ≈ 2.5:1).
const VIEW_BOX = '27.857 167.108 464.286 185.781';
const ASPECT = 464.286 / 185.781;

export const SiteLogo = ({ height = 26 }: { height?: number }): JSX.Element => (
  <svg
    className='site-header__logo'
    role='img'
    aria-label='GLG'
    height={height}
    width={Math.round(height * ASPECT)}
    viewBox={VIEW_BOX}
    fill='currentColor'
    xmlns='http://www.w3.org/2000/svg'
    style={{ display: 'block' }}
  >
    <title>GLG</title>
    <path d='M27.857 260.132C27.857 207.501 61.2715 167.111 116.38 167.111C163.008 167.111 192.446 191.295 198.177 230.95H147.802C145.065 219.477 134.336 210.001 118.378 210.001C93.4394 210.001 80.7296 230.95 80.7296 260.132C80.7296 289.301 95.1828 310.995 120.372 310.995C139.329 310.995 148.559 300.773 151.791 288.804H118.376V251.898H201.669V348.65H166.998L163.008 329.703H162.513C151.301 345.916 133.094 352.892 111.396 352.892C87.4571 352.892 66.9985 344.657 52.543 329.192C36.0864 311.742 27.857 287.801 27.857 260.132Z' />
    <path d='M208.867 170.356H260.985V304.016H324.167V348.65H208.867V170.356Z' />
    <path d='M453.494 329.703H452.997C441.775 345.916 423.575 352.892 401.872 352.892C377.936 352.892 357.489 344.657 343.02 329.192C326.566 311.74 318.338 287.799 318.338 260.13C318.338 207.499 351.755 167.108 406.859 167.108C453.498 167.108 482.913 191.293 488.656 230.947H438.288C435.549 219.475 424.817 209.999 408.855 209.999C383.921 209.999 371.199 230.947 371.199 260.13C371.199 289.299 385.671 310.992 410.847 310.992C429.808 310.992 439.029 300.771 442.27 288.802H408.853V251.898H492.143V348.65H457.487L453.494 329.703Z' />
  </svg>
);
